export default __webpack_public_path__ + "static/media/prodslide2.4545de9d.jpg";